import React from 'react';
import { MessageSquare, Languages } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
export function Nav() {
  const {
    lang,
    toggle,
    t
  } = useLanguage();
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-cream/90 backdrop-blur-md border-b border-taupe/50" data-id="element-65">
      <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-66">
        <div className="flex items-center gap-2" data-id="element-67">
          <MessageSquare className="w-5 h-5 text-coral" data-id="element-68" />
          <span className="font-serif text-xl font-medium tracking-tight" data-id="element-69">
            MyCodeEx
          </span>
        </div>

        <div className="flex items-center gap-2 sm:gap-4" data-id="element-70">
          <button type="button" onClick={toggle} aria-label={lang === 'es' ? 'Switch to English' : 'Cambiar a Español'} className="group flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-taupe hover:border-coral hover:text-coral transition-colors text-sm font-medium" data-id="element-71">
            <Languages className="w-4 h-4" data-id="element-72" />
            <span className="tabular-nums" data-id="element-73">
              <span className={lang === 'es' ? 'text-coral' : 'text-muted'} data-id="element-74">
                ES
              </span>
              <span className="text-muted mx-1" data-id="element-75">/</span>
              <span className={lang === 'en' ? 'text-coral' : 'text-muted'} data-id="element-76">
                EN
              </span>
            </span>
          </button>

          <a href="#pricing" className="hidden sm:inline text-sm font-medium text-ink hover:text-coral transition-colors" data-id="element-77">
            {t.nav.cta}
          </a>
        </div>
      </div>
    </nav>;
}